import { createApi } from '@reduxjs/toolkit/query/react'
import { ARCHIVE_SCHOOL_CLIENT, CREATE_SCHOOL_CLIENT, FAVOURITE_CLIENT_REPORT, FAVOURITE_SCHOOL_CLIENT, LIST_SCHOOL_CLIENT, REMOVE_SCHOOL_CLIENT, UPDATE_SCHOOL_CLIENT, VIEW_SCHOOL_CLIENT } from "config/apiPaths"
import { RTK_CACHE_EXPIRATION } from "config/constants"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const schoolClientsApi = createApi({
  reducerPath: 'schoolClientsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: "/client/school",
  }),
  tagTypes: ["SchoolClients", "SchoolClientDetails"],
  keepUnusedDataFor: RTK_CACHE_EXPIRATION,
  endpoints: (builder) => ({
    // get School clients list
    getSchoolClientsList: builder.query({
      query: ({ search = "",therapist_id = '', status = "", grade = "", page = 1, limit = 10, division = "", school = "", sort = { column: "id", direction: "ASC" } }) => {
        return ({
          method: "PATCH",
          url: LIST_SCHOOL_CLIENT,
          data: {
            search,
            status: status?.value,
            page,
            limit,
            division: division?.value,
            sort,
            school: school?.value,
            grade: grade?.value,
            therapist_id
          },
        })
      },
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["SchoolClients"]
    }),

    // get School profile
    getSchoolClientData: builder.query({
      query: (id) => ({
        method: "GET",
        url: `${VIEW_SCHOOL_CLIENT}/${id}`
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["SchoolClientDetails"]
    }),

    // create School profile
    createSchoolClient: builder.mutation({
      query: (data) => ({
        method: "POST",
        url: CREATE_SCHOOL_CLIENT,
        data
      }),
      invalidatesTags: ["SchoolClients"]
    }),

    // update School profile
    updateSchoolClient: builder.mutation({
      query: (data) => ({
        method: "PUT",
        url: `${UPDATE_SCHOOL_CLIENT}/${data.id}`,
        data: data.payload
      }),
      invalidatesTags: ["SchoolClients", "SchoolClientDetails"]
    }),

    // delete School profile
    deleteSchoolClient: builder.mutation({
      query: (id) => ({
        method: "DELETE",
        url: `${REMOVE_SCHOOL_CLIENT}/${id}`
      }),
      invalidatesTags: ["SchoolClients"]
    }),

    // archive school profile
    archiveSchoolClient: builder.mutation({
      query: (id) => ({
        method: "DELETE",
        url: `${ARCHIVE_SCHOOL_CLIENT}/${id}`
      }),
      invalidatesTags: ["SchoolClients", "SchoolClientDetails"]
    }),

    favouriteSchoolClient: builder.mutation({
      query: ({ data, id }) => ({
        method: "PATCH",
        url: `${FAVOURITE_SCHOOL_CLIENT}/${id}`,
        data
      }),
      invalidatesTags: ["SchoolClients", "SchoolClientDetails"]
    }),

    favouriteReport: builder.mutation({
      query: ({ data, id }) => ({
        method: "PATCH",
        url: `${FAVOURITE_CLIENT_REPORT}/${id}`,
        data
      }),
      invalidatesTags: ["reportsList"]
    }),

  }),
})

export const {
  useGetSchoolClientsListQuery,
  useCreateSchoolClientMutation,
  useGetSchoolClientDataQuery,
  useUpdateSchoolClientMutation,
  useDeleteSchoolClientMutation,
  useLazyGetSchoolClientsListQuery,
  useArchiveSchoolClientMutation,
  useLazyGetSchoolClientDataQuery,
  useFavouriteSchoolClientMutation,
  useFavouriteReportMutation
} = schoolClientsApi;